export default {
  pt: {
    sloganLine1: "Segurança sem franquia, liberdade sem custo",
    sloganLine2: "Saia da loja segurado",
    activateButton: "Ativar Seguro",
    tutorialButton: "Veja o Tutorial",
    storeNotFound:
      "A loja não está cadastrada no programa de seguros. Contate o suporte para mais informações.",
    privacyPolicyLink: "Política de Privacidade",
  },

  en: {
    sloganLine1: "No deductible security, cost-free freedom",
    sloganLine2: "Leave the store insured",
    activateButton: "Activate Insurance",
    tutorialButton: "Watch the Tutorial",
    storeNotFound:
      "The store is not registered in the insurance program. Please contact support for more information.",
    privacyPolicyLink: "Privacy Policy",
  },
};
